import React from 'react';
import View from '../../table/view'
import { createCheckoutLog, deleteCheckoutLog, getCheckoutLogs, updateCheckoutLog } from '../../slices/checkout-log'

const CheckoutLog = () => {
  const columnDefs = [
    { field: 'id', headerName: 'Id', sortable: true, minWidth: 200, checkboxSelection: true },
    { field: 'duration', headerName: 'Duration', sortable: true, minWidth: 120, checkboxSelection: true },
    { field: 'checkoutLogChannelId', headerName: 'Channel Id', sortable: true, minWidth: 200, checkboxSelection: true },
    { field: 'checkoutLogLicenseId', headerName: 'License Id', sortable: true, minWidth: 200, checkboxSelection: true },
  ];
  return (
    <View
      name="Checkout Log"
      columnDefs={columnDefs}
      deleteFunction={deleteCheckoutLog}
      getFunction={getCheckoutLogs}
      updateFunction={updateCheckoutLog}
      createFunction={createCheckoutLog}
      stateSelector={(state) => state.checkoutLog}
      addEnabled={false}
      deleteEnabled={false}
    />
  )
}

export default CheckoutLog;
